import { defineComponent as _defineComponent } from 'vue'
import { computed as _computed } from 'vue';

import __MACROS_useVModel from "/vue-macros/define-models/use-vmodel";
import { AssetHeaderDto, AssetSummaryDtoV2 } from '@/api';
import i18n from '@/i18n';
import formatDate from '@/utils/filters/formatDate';


export default /*#__PURE__*/_defineComponent({
  __name: 'Quality-Status',
  props: {
  count: null,
  value: null,
  missingSince: null,
  scheduledDeletionDate: null
},
  emits: ["input", "update:missingSince", "update:scheduledDeletionDate"],
  setup(__props) {

const props = __props;



const { value: model, missingSince, scheduledDeletionDate } = __MACROS_useVModel(["value", undefined, "input"], "missingSince", "scheduledDeletionDate");

const showStatus = _computed(() => (model.value !== AssetHeaderDto.qualityStatus.NOT_SUPPORTED && model.value !== AssetSummaryDtoV2.healthStatus.NOT_SUPPORTED));

const showMissingTooltip = _computed(() => (
  (model.value === AssetHeaderDto.qualityStatus.MISSING || model.value === AssetSummaryDtoV2.healthStatus.MISSING)
  && (missingSince.value != null || scheduledDeletionDate.value != null)
));

const tooltipDeletionLine = _computed(() => (
  scheduledDeletionDate.value != null
    ? i18n.t('qualityStatus.missing_tooltip.deletion_planned', { date: formatDate(scheduledDeletionDate.value) })
    : null
));

const tooltipMissingSinceLine = _computed(() => (
  missingSince.value != null
    ? i18n.t('qualityStatus.missing_tooltip.missing_since', { date: formatDate(missingSince.value) })
    : null
));

const chip = _computed(() => {
  const baseText = (() => {
    switch (model.value) {
      case AssetHeaderDto.qualityStatus.CRITICAL:
      case AssetSummaryDtoV2.healthStatus.CRITICAL:
        return i18n.t('qualityStatus.critical');
      case AssetHeaderDto.qualityStatus.AT_RISK:
      case AssetSummaryDtoV2.healthStatus.AT_RISK:
        return i18n.t('qualityStatus.at_risk');
      case AssetHeaderDto.qualityStatus.HEALTHY:
      case AssetSummaryDtoV2.healthStatus.HEALTHY:
        return i18n.t('qualityStatus.healthy');
      case AssetHeaderDto.qualityStatus.MISSING:
      case AssetSummaryDtoV2.healthStatus.MISSING:
        return i18n.t('qualityStatus.missing');
      case AssetHeaderDto.qualityStatus.UNMONITORED:
      case AssetSummaryDtoV2.healthStatus.UNMONITORED:
        return i18n.t('qualityStatus.unmonitored');
      case AssetHeaderDto.qualityStatus.NOT_SUPPORTED:
      case AssetSummaryDtoV2.healthStatus.NOT_SUPPORTED:
        return i18n.t('qualityStatus.not_supported');
      default:
        return i18n.t('qualityStatus.not_supported');
    }
  })();

  const text = (model.value === AssetHeaderDto.qualityStatus.HEALTHY || model.value === AssetSummaryDtoV2.healthStatus.HEALTHY)
    || props.count === undefined
    ? baseText
    : `${props.count} ${baseText}`;

  switch (model.value) {
    case AssetHeaderDto.qualityStatus.CRITICAL:
    case AssetSummaryDtoV2.healthStatus.CRITICAL:
      return {
        text,
        color: 'iconDanger',
        textColor: 'textDanger--text',
        icon: 'icon-error-circle-fill',
        iconColor: 'iconDanger',
      };
    case AssetHeaderDto.qualityStatus.AT_RISK:
    case AssetSummaryDtoV2.healthStatus.AT_RISK:
      return {
        text,
        color: 'iconWarning',
        textColor: 'textWarning--text',
        icon: 'icon-warning-fill',
        iconColor: 'iconWarning',
      };
    case AssetHeaderDto.qualityStatus.HEALTHY:
    case AssetSummaryDtoV2.healthStatus.HEALTHY:
      return {
        text,
        color: 'iconSuccess',
        textColor: 'textSuccess--text',
        icon: 'icon-check-circle-fill',
        iconColor: 'iconSuccess',
      };
    case AssetHeaderDto.qualityStatus.MISSING:
    case AssetSummaryDtoV2.healthStatus.MISSING:
      return {
        text,
        color: 'borderSecondary',
        textColor: 'textPrimary--text',
        icon: 'icon-dismiss-circle-fill',
        iconColor: 'textPrimary',
      };
    case AssetHeaderDto.qualityStatus.UNMONITORED:
    case AssetSummaryDtoV2.healthStatus.UNMONITORED:
      return {
        text,
        color: 'borderPrimary',
        textColor: 'textSecondary--text',
        icon: 'icon-circle-slash',
        iconColor: 'iconNeutral',
      };
    case AssetHeaderDto.qualityStatus.NOT_SUPPORTED:
    case AssetSummaryDtoV2.healthStatus.NOT_SUPPORTED:
      return {
        text,
        color: 'borderPrimary',
        textColor: 'textSecondary--text',
        icon: 'icon-circle-slash',
        iconColor: 'iconNeutral',
      };
    default:
      return {
        text,
        color: 'borderPrimary',
        textColor: 'textSecondary--text',
        icon: 'icon-circle-slash',
        iconColor: 'iconNeutral',
      };
  }
});


return { __sfc: true,props, model, missingSince, scheduledDeletionDate, showStatus, showMissingTooltip, tooltipDeletionLine, tooltipMissingSinceLine, chip, _computed, __MACROS_useVModel, AssetHeaderDto, AssetSummaryDtoV2, i18n, formatDate }
}

})